module.exports = __webpack_public_path__ + "img/aliapyTips2.b65d419a.png";